import React from "react";
import "./Trusted.css";

// IMPORT YOUR LOGOS HERE
import layers from "../../../../assets/images/work/c1.png";
import sisyphus from "../../../../assets/images/work/c2.png";
import circo from "../../../../assets/images/work/c3.png";
import catalog from "../../../../assets/images/work/c4.png";
import quotient from "../../../../assets/images/work/c5.png";

const Trusted = () => {
  return (
    <section className="trusted">
      <div className="trusted__container">

        {/* TOP SMALL TEXT */}
        <p className="trusted__subtitle">
          Trusted by Leading Brands
        </p>

        {/* MAIN TITLE */}
        <h2 className="trusted__title">
          Some of the Brands We Empower
        </h2>

        {/* DESCRIPTION */}
        <p className="trusted__desc">
          We focus on outcomes that matter – performance, scalability, and real user value.
        </p>

        {/* LOGOS */}
        <div className="trusted__logos">

          <div className="trusted__logo">
            <img src={layers} alt="Layers" />
          </div>

          <div className="trusted__logo">
            <img src={sisyphus} alt="Sisyphus" />
          </div>

          <div className="trusted__logo">
            <img src={circo} alt="Circo" />
          </div>

          <div className="trusted__logo">
            <img src={catalog} alt="Catalog" />
          </div>

          <div className="trusted__logo">
            <img src={quotient} alt="Quotient" />
          </div>

        </div>

      </div>
    </section>
  );
};

export default Trusted;